import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    backgroundColor: 'inherit',
    width: '32px',
    height: '32px',
  },
  menuList: {
    '&.MuiMenu-list': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  menuListItem: {
    borderRadius: theme.misc.borderRadius,
    '&:hover': {
      backgroundColor: 'var(--ds-color-neutral-100, #f1f5f9)',
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.common.brandTint,
      '&:hover': {
        backgroundColor: theme.palette.common.brandSelectedHover,
      },
      '& p': {
        color: theme.palette.common.blue400,
      },
    },
  },
}));

export default useStyles;
